{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "(säästä {highestYearlyDiscount} %)",
    "{amount} days free": "{amount} päivää ilmaiseksi",
    "{amount} off": "{amount} pois",
    "{amount} off for first {number} months.": "{amount} pois ensimmäisestä {number} kuukaudesta.",
    "{amount} off for first {period}.": "{amount} pois ensimmäisestä {period}.",
    "{amount} off forever.": "{amount} pois ikuisesti.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount} % alennus",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} ei enää jatkossa saa {newsletterName} uutiskirjettä.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} ei lähetetä enää jatkossa sähköpostia jos joku vastaa kommenttiisi.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} ei enää lähetetä tätä uutiskirjettä.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} päivää ilmaiseksi",
    "{years} years": "",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Oma tili",
    "Account details updated successfully": "Tilin lisätiedot on päivitetty",
    "Account settings": "Tilin asetukset",
    "Add a personal note": "Lisää oma viesti",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Kun ilmainen kokeilusi loppuu, sinulta veloitetaan valitsemasi tilauksen maksu. Voit aina peruuttaa tilauksesi ennen tätä.",
    "Already a member?": "Oletko jo jäsen?",
    "An error occurred": "On tapahtunut virhe",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Odottamaton virhe syntyi, yritäthän uudestaan tai <a>contact support</a> jos ongelma jatkuu.",
    "Back": "Takaisin",
    "Back to Log in": "Takaisin kirjautumiseen",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Peruuta milloin vain",
    "Cancel subscription": "Peruuta tilaus",
    "Canceled": "",
    "Cancellation reason": "Syy peruutukselle",
    "Change": "Vaihda",
    "Change plan": "Vaihda tilausta",
    "Check spam & promotions folders": "Katso spam & promotions kansiot",
    "Check with your mail provider": "Tarkista sähköpostitarjoajaltasi",
    "Check your inbox to verify email update": "Tarkista sähköpostilaatikkosi, jotta voit vahvistaa sähköpostiosoitteen päivityksen",
    "Choose": "Valitse",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Valitse toinen tilaus",
    "Choose a plan": "Valitse tilaus",
    "Choose a tier": "",
    "Choose your newsletters": "Valitse uutiskirjeesi",
    "City": "",
    "Click here to retry": "Klikkaa tästä kokeillaksesi uudestaan",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Sulje",
    "Code": "Koodi",
    "Comment preferences updated.": "Kommenttiasetukset on päivitetty.",
    "Comments": "Kommentit",
    "Complimentary": "Maksuton",
    "Confirm": "Vahvista",
    "Confirm cancellation": "Vahvista peruutus",
    "Confirm subscription": "Vahvista tilaus",
    "Contact support": "Ota yhteyttä tukeen",
    "Continue": "Jatka",
    "Continue subscription": "Jatka tilaustasi",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Maksaminen Stripe-palvelussa ei onnistu",
    "Could not sign in. Login link expired.": "Kirjautuminen epäonnistui. Kirjautumislinkki on vanhentunut.",
    "Could not update email! Invalid link.": "Sähköpostia ei pystytty päivittämään! Linkki ei toimi.",
    "Country": "",
    "Create a new contact": "Luo uusi kontakti",
    "Current plan": "Nykyinen tilaus",
    "Delete account": "Poista tilisi",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Etkö tarkoittanut tehdä näin? Muokkaa valintojasi <button>here</button>",
    "Don't have an account?": "Eikö sinulla ole tiliä?",
    "Edit": "Muokkaa",
    "Email": "Sähköposti",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Uutiskirje sähköpostiin",
    "Email newsletter settings updated": "Uutiskirjeen asetukset on päivitetty",
    "Email preferences": "Sähköpostiasetukset",
    "Email preferences updated.": "Sähköpostiasetukset on päivitetty.",
    "Emails": "Sähköpostit",
    "Emails disabled": "Sähköpostit pois käytöstä",
    "Ends {offerEndDate}": "Loppuu {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "Syötä koodi yläpuolelle",
    "Enter the recipient's email address": "",
    "Enter your email address": "Syötä sähköpostiosoitteesi",
    "Enter your name": "Syötä nimesi",
    "Error": "Virhe",
    "Expires {expiryDate}": "Vanhenee {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Tilauksen peruutus ei onnistunut, yritäthän uudestaan",
    "Failed to log in, please try again": "Sisäänkirjautuminen ei onnistunut, yritäthän uudestaan",
    "Failed to log out, please try again": "Uloskirjautuminen ei onnistunut, yritäthän uudestaan",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Maksaminen ei onnistunut, yritäthän uudestaan",
    "Failed to send magic link email": "Kirjautumislinkin lähetys ei onnistunut",
    "Failed to send verification email": "Vahvistussähköpostin lähetys ei onnistunut",
    "Failed to sign up, please try again": "Rekisteröityminen ei onnistunut, yritäthän uudestaan",
    "Failed to update account data": "Tilitietojen päivitys ei onnistunut",
    "Failed to update account details": "Tilin lisätietojen päivitys ei onnistunut",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Uutiskirjeen asetusten päivitys ei onnistunut",
    "Failed to update subscription, please try again": "Tilauksen päivitys ei onnistunut, yritäthän uudestaan",
    "Failed to verify code, please try again": "Koodin vahvistus ei onnistunut, yritäthän uudestaan",
    "For a friend or colleague": "",
    "Forever": "Ikuisesti",
    "Free Trial – Ends {trialEnd}": "Ilmainen kokeilu – Loppuu {trialEnd}",
    "From": "",
    "Get help": "Pyydä apua",
    "Get in touch for help": "Ota yhteyttä saadaksesi apua",
    "Get notified when someone replies to your comment": "Saa viesti kun joku vastaa kommenttiisi",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Anna palautetta tähän postaukseen",
    "Help! I'm not receiving emails": "Apua! En saa sähköposteja",
    "Here are a few other sites you may enjoy.": "Saatat pitää myös seuraavista sivuista.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Jos uutiskirje on merkitty spammiksi, sähköpostit tähän osoitteeseen on estetty, jotta et enää vastaanota viestejä osoitteeseen",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Jos spam-valitus oli aiheeton, tai haluaisit saada taas viestejä, voit uudelleen ilmoittautua sähköposteihin painamalla nappia edellisellä sivulla.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Jos haluat perua tilauksesi nyt, sinulla on vielä oikeus materiaaliin {periodEnd} asti",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Jos sinulla on yritys- tai valtion sähköposti, pyydä IT-osastoa hyväksymään sähköpostit lähettäjältä {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Kirjautumislinkki on lähetetty sähköpostiisi. Jos se ei tule 3 minuutin kuluessa, muista katsoa spam-kansiosi.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "Sähköposti on lähetetty: {submittedEmailOrInbox}. Napsauta viestissä olevaa linkkiä tai kirjoita koodi alapuolelle.",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Jos haluat saada taas sähköposteja, paras tapa jatkaa on tarkistaa sähköpostiosoitteesi ja sitten klikata uudelleen uutiskirjeeseen osallistumista edellisellä sivulla.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Jos et saa uutiskirjettä sähköpostiisi, tässä on muutama asia tarkistettavaksi:",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Jos et vieläkään saa uutiskirjeitä, ota yhteyttä {supportAddress}",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Jos uutiskirjeen lähetyksessä tapahtuu pysyvä ongelma, sähköpostien lähetys keskeytetään.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Sähköpostiasetuksissasi lisää {senderEmail} kontakteihisi. Tämä antaa viestin sähköpostitarjoajalle, että viestit tästä osoitteesta ovat hyväksyttäviä.",
    "Invalid email address": "Sähköpostiosoite on virheellinen",
    "Invalid verification code": "Vahvistuskoodi on virheellinen",
    "Jamie Larson": "Janne Lahtinen",
    "jamie@example.com": "janne@esimerkki.fi",
    "Less like this": "Vähemmän tämän kaltaisia",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Varmista, että sähköpostit eivät mene Spam- tai roskapostikansioihin, Jos näin käy, klikkaa \"Mark as not spam\" ja/tai \"Move to inbox\".",
    "Manage": "Hallitse",
    "Maybe later": "Ehkä myöhemmin",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "Tätä sähköpostidomainia käyttävien henkilöiden jäsenyyttä on tällä hetkellä rajoitettu.",
    "Memberships unavailable, contact the owner for access.": "Jäsenyydet eivät ole käytettävissä. Otathan yhteyttä sivuston omistajaan.",
    "month": "kuukausi",
    "Monthly": "Kuukausittainen",
    "More like this": "Lisää tämän kaltaista",
    "More options": "",
    "Name": "Nimi",
    "Need more help? Contact support": "Tarvitsetko lisää apua? Ota yhteyttä tukeen",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Uutiskirjeet sähköpostiisi voivat peruuntua kahdesta syystä: edellinen sähköposti oli merkattu spammiksi, tai sähköpostin lähetyksestä tuli bounce.",
    "No member exists with this e-mail address.": "Tälle sähköpostiosoitteelle ei löydy jäsenyyttä.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Etkö saa sähköposteja?",
    "Now": "",
    "Now check your email!": "Nyt tarkista sähköpostisi",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Kun olet tilannut sähköpostit uudelleen ja et vieläkään saa posteja, katso ensimmäiseksi spam-kansio. Jotkut tarjoajat pitävät listaa ennen merkityistä viesteistä ja estävät niitä jatkossakin. Jos näin tapahtuu, merkitse viesti Not Spam ja siirrä se postilaatikkoosi.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Pysyvä virhe (bounce)",
    "Phone number": "Puhelinnumero",
    "Plan": "Tilaus",
    "Plan checkout was cancelled.": "Tilauksen maksaminen on peruttu",
    "Plan upgrade was cancelled.": "Tilauksen korotus on peruttu",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Voit tehdä muutoksia maksuttomaan tilaukseesi ottamalla yhteyttä osoitteeseen {supportAddress}.",
    "Please enter {fieldName}": "Täytä kenttä {fieldName}",
    "Please fill in required fields": "Täytä tarvittavat kentät",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "Hyväksy sähköpostit uudelleen",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Suositukset",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Tilaus uusiutuu hinnalla {price}.",
    "Resume subscription": "",
    "Retry": "Kokeile uudestaan",
    "Save": "Tallenna",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Lähetetään kirjautumislinkkiä...",
    "Sending...": "Lähetetään...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Näytä kaikki",
    "Sign in": "Kirjaudu sisään",
    "Sign out": "Kirjaudu ulos",
    "Sign up": "Rekisteröidy",
    "Signup error: Invalid link": "Virhe rekisteröinnissä: Linkki ei toimi",
    "Signups from this email domain are currently restricted.": "Tätä sähköpostidomainia käyttävien henkilöiden rekisteröitymistä on tällä hetkellä rajoitettu.",
    "Something went wrong, please try again later.": "Jotain meni pieleen, ole hyvä ja yritä uudestaan myöhemmin.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Valitettavasti suositukset eivät ole juuri nyt käytettävissä.",
    "Sorry, that didn’t work.": "Anteeksi, tämä ei onnistunut",
    "Spam complaints": "Spam-valitukset",
    "Start {amount}-day free trial": "Aloita {amount}-päivän kokeilu",
    "Starting {startDate}": "Aloitetaan {startDate}",
    "Starting today": "Alkaa tänään",
    "State": "",
    "Submit feedback": "Anna palautetta",
    "Subscribe": "Tilaa",
    "Subscribed": "Tilaus onnistunut",
    "Subscription plan updated successfully": "Tilaus on päivitetty",
    "Success": "Onnistunut",
    "Success! Check your email for magic link to sign-in.": "Onnistui! Katso sähköpostisi kirjautumislinkkiä varten",
    "Success! Your account is fully activated, you now have access to all content.": "Onnistui! Tilisi on aktivoitu ja sinulla on pääsy sisältöihin",
    "Success! Your email is updated.": "Onnistui! Sähköpostisi on päivitetty",
    "Successfully unsubscribed": "Tilauksen peruutus onnistui",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Kiitos tilauksesta. Ennen kuin aloitat lukemisen, tässä on joitakin muita sivuja, joista saatat pitää.",
    "Thank you for your support": "Kiitos tuestasi",
    "Thank you for your support!": "Kiitos tuestasi!",
    "Thanks for the feedback!": "Kiitos palautteestasi!",
    "That didn't go to plan": "Tämä ei mennyt suunnitelmien mukaan",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Sähköpostisi järjestelmässä on {memberEmail} — jos se ei ole oikea, voit päivittää sen <button>tilin asetuksissa</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Meillä oli ongelma palautteesi lähetyksen kanssa. Kokeilethan myöhemmin uudestaan.",
    "There was an error cancelling your subscription, please try again.": "Tilauksen peruutuksessa tapahtui virhe, yritäthän uudestaan.",
    "There was an error continuing your subscription, please try again.": "Tilauksen jatkamisessa tapahtui virhe, yritäthän uudestaan.",
    "There was an error processing your payment. Please try again.": "Maksun käsittelyssä tapahtui virhe, yritäthän uudestaan.",
    "There was an error sending the email, please try again": "Sähköpostin lähetyksessä tapahtui virhe, yritäthän uudestaan",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Tämä sivu on vain kutsutuille, ota yhteyttä omistajaan saadaksesi pääsyoikeuden.",
    "This site is not accepting donations at the moment.": "Tämä sivu ei vastaanota lahjoituksia juuri nyt.",
    "This site is not accepting payments at the moment.": "Tämä sivu ei vastaanota maksuja juuri nyt.",
    "This site only accepts paid members.": "Tämä sivu on vain maksaville jäsenille.",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Viimeistelläksesi rekisteröitymisen, klikkaa vahvistuslinkkiä sähköpostissasi. Jos sitä ei saavu 3 minuutin kuluessa, tarkista roskapostikansiosi!",
    "To continue to stay up to date, subscribe to {publication} below.": "Jotta saat tietoa päivityksistä, tilaa {publication} alla.",
    "Too many attempts try again in {number} days.": "Liian monta yritystä. Yritä uudelleen {number} päivän kuluttua.",
    "Too many attempts try again in {number} hours.": "Liian monta yritystä. Yritä uudelleen {number} tunnin kuluttua.",
    "Too many attempts try again in {number} minutes.": "Liian monta yritystä. Yritä uudelleen {number} minuutin kuluttua.",
    "Too many different sign-in attempts, try again in {number} days": "Liian monta erilaista yritystä kirjautua sisään. Yritä uudelleen {number} päivän kuluttua.",
    "Too many different sign-in attempts, try again in {number} hours": "Liian monta erilaista yritystä kirjautua sisään. Yritä uudelleen {number} tunnin kuluttua.",
    "Too many different sign-in attempts, try again in {number} minutes": "Liian monta erilaista yritystä kirjautua sisään. Yritä uudelleen {number} minuutin kuluttua.",
    "Too many sign-up attempts, try again later": "Liian monta yritystä rekisteröityä. Yritä uudelleen myöhemmin.",
    "Try free for {amount} days, then {originalPrice}.": "Kokeile ilmaiseksi {amount} päivää, sen jälkeen hinta on {originalPrice}.",
    "Unable to initiate checkout session": "Maksutapahtuman aloitus ei onnistu",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Avaa pääsy kaikkiin uutiskirjeisiin maksullisella tilauksella.",
    "Unsubscribe from all emails": "Peruuta kaikki sähköpostit",
    "Unsubscribed": "Tilaus peruutettu",
    "Unsubscribed from all emails.": "Kaikkien sähköpostien tilaus on peruutettu.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Sähköpostien peruuttaminen ei peruuta maksullista tilaustasi {title}",
    "Update": "Päivitä",
    "Update your preferences": "Päivitä asetuksesi",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Vahvistuslinkki lähetetty, tarkista sähköpostisi",
    "Verify your email address is correct": "Vahvista sähköpostiosoitteesi oikeellisuus",
    "Verifying...": "Tarkistetaan...",
    "View plans": "Katso tilausvaihtoehtoja",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Emme voineet peruuttaa tilaustasi, koska sähköpostiosoitetta ei löytynyt. Ota yhteyttä sivuston omistajaan.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Tervetuloa takaisin, {name}!",
    "Welcome back!": "Tervetuloa takaisin!",
    "Welcome to {siteTitle}": "Tervetuloa sivulle {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Jos sähköpostilaatikko ei pysty vastaanottamaan viestiä, sitä kutsutaan “bounssaamiseksi”. Usein se on väliaikaista. Joissakin tapauksissa “bounssannut” sähköposti voi kuitenkin palautua pysyvänä virheenä, kun sähköpostiosoite on virheellinen tai sitä ei ole olemassa.",
    "Why has my email been disabled?": "Miksi sähköpostini on poistettu käytöstä?",
    "X (Twitter)": "",
    "year": "vuosi",
    "Yearly": "Vuosittainen",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Sinulla on tällä hetkellä ilmainen jäsenyys, päivitä maksulliseksi tilaukseksi saadaksesi täyden pääsyn.",
    "You have been successfully resubscribed": "Olet tilannut uudelleen onnistuneesti",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Et tällä hetkellä ole saamassa sähköposteja",
    "You're not receiving emails": "Et saa sähköposteja",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Et saa sähköposteja siksi, että joko merkitsit äskettäisen viestin roskapostiksi tai siksi, että viestejä ei voitu toimittaa antamaasi sähköpostiosoitteeseen.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Olet kirjautunut sisään onnistuneesti",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Tilaus onnistui: <strong>{siteTitle}</strong>",
    "Your account": "Tilisi",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Tilauksen uusiminen epäonnistui sähköpostillesi. Yritäthän uudelleen.",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "sähköpostilaatikkoosi",
    "Your input helps shape what gets published.": "Antamasi palautteen avulla muokataan julkaistavaa sisältöä",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Tilauksesi päättyy {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Tilauksesi uusiutuu {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Tilauksesi alkaa {subscriptionStart}"
}
